export const VALIDATE_QB_CARD = '/api/reseller/validateQbCard';
